import { Box, CircularProgress, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import { CircularProgressProps } from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { selectProgress } from '../../../store/loading/loading.selector';

function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number | undefined }
) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress size="6rem" {...props} />
            {props.value !== undefined && (
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                        }}
                    >{`${Math.round(props.value)}%`}</Typography>
                </Box>
            )}
        </Box>
    );
}

const LoadingSpinner = () => {
    const progress = useSelector(selectProgress);

    return (
        <Backdrop sx={{ color: '#fff', zIndex: () => 1500 }} open>
            <CircularProgressWithLabel color="primary" value={progress} />
        </Backdrop>
    );
};

export default LoadingSpinner;
